import { Controller } from "@hotwired/stimulus"

// 사용자 선택 모달 컨트롤러 (정산 대상자 검색용)
export default class extends Controller {
  static targets = ["modal", "input", "selectedName", "searchInput", "list"]
  static values = {
    users: Array
  }

  connect() {
    this.updateDisplay()
  }

  openModal(event) {
    event.preventDefault()
    this.renderList()
    this.modalTarget.showModal()
    // 검색 입력 필드에 포커스
    setTimeout(() => {
      if (this.hasSearchInputTarget) {
        this.searchInputTarget.focus()
      }
    }, 100)
  }

  closeModal() {
    this.modalTarget.close()
  }

  search(event) {
    const query = event.target.value.toLowerCase().trim()
    this.renderList(query)
  }

  renderList(query = '') {
    const users = this.usersValue
    const filteredUsers = query
      ? users.filter(u => u.name.toLowerCase().includes(query))
      : users

    if (filteredUsers.length === 0) {
      this.listTarget.innerHTML = `
        <div class="text-center py-8 text-gray-500">
          <p>검색 결과가 없습니다</p>
        </div>
      `
      return
    }

    const currentValue = this.inputTarget.value

    this.listTarget.innerHTML = filteredUsers.map(user => `
      <button type="button"
              class="w-full flex items-center justify-between px-4 py-3 hover:bg-gray-50 transition-colors ${user.id.toString() === currentValue ? 'bg-blue-50' : ''}"
              data-action="click->user-select-modal#selectUser"
              data-id="${user.id}"
              data-name="${user.name}">
        <div class="text-left">
          <p class="font-medium text-gray-900">${user.name}</p>
          <p class="text-sm text-gray-500">${user.role_label || ''}</p>
        </div>
        ${user.id.toString() === currentValue ? `
          <svg class="w-5 h-5 text-blue-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
          </svg>
        ` : ''}
      </button>
    `).join('')
  }

  selectUser(event) {
    const id = event.currentTarget.dataset.id
    const name = event.currentTarget.dataset.name

    this.inputTarget.value = id
    this.selectedNameTarget.textContent = name
    this.selectedNameTarget.classList.remove('text-gray-400')
    this.selectedNameTarget.classList.add('text-gray-900')

    this.closeModal()

    // Change 이벤트 발생
    this.inputTarget.dispatchEvent(new Event('change', { bubbles: true }))
  }

  clearSelection(event) {
    event.preventDefault()
    this.inputTarget.value = ''
    this.selectedNameTarget.textContent = '전체'
    this.selectedNameTarget.classList.add('text-gray-400')
    this.selectedNameTarget.classList.remove('text-gray-900')
  }

  updateDisplay() {
    const currentValue = this.inputTarget.value
    if (currentValue) {
      const user = this.usersValue.find(u => u.id.toString() === currentValue)
      if (user && this.hasSelectedNameTarget) {
        this.selectedNameTarget.textContent = user.name
        this.selectedNameTarget.classList.remove('text-gray-400')
        this.selectedNameTarget.classList.add('text-gray-900')
      }
    }
  }

  // ESC 키로 모달 닫기
  handleKeydown(event) {
    if (event.key === "Escape") {
      this.closeModal()
    }
  }

  // 모달 외부 클릭 시 닫기
  handleBackdropClick(event) {
    if (event.target === this.modalTarget) {
      this.closeModal()
    }
  }
}
